import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function Hotel2Icon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M13.8 18C13.8 18.4 13.5 18.8 13 18.8H11C10.6 18.8 10.2 18.5 10.2 18C10.2 17.5 10.5 17.2 11 17.2H13C13.4 17.2 13.8 17.5 13.8 18ZM13 11.3H11C10.6 11.3 10.2 11.6 10.2 12.1C10.2 12.6 10.5 12.9 11 12.9H13C13.4 12.9 13.8 12.6 13.8 12.1C13.8 11.6 13.5 11.3 13 11.3ZM13 14.2H11C10.6 14.2 10.2 14.5 10.2 15C10.2 15.5 10.5 15.8 11 15.8H13C13.4 15.8 13.8 15.5 13.8 15C13.8 14.5 13.5 14.2 13 14.2ZM21.9 22.8H2.00003C1.60003 22.8 1.20003 22.5 1.20003 22C1.20003 21.5 1.61055 21.2 2.00003 21.2H2.20003V13C2.20003 11.8 2.70003 11.2 4.00003 11.2H6.20003V11C6.20003 8.1 7.00003 7.2 10 7.2H12.2V3.2C12.2 2.5 12.2 1.7 12.9 1.4C13.5 1.1 14.1 1.4 14.8 1.6L19.1 3.8C20.3 4.4 20.9 4.7 21.3 5.4C21.7 6.1 21.7 6.8 21.7 8.1V21.2H21.9C22.3 21.2 22.7 21.5 22.7 22C22.7 22.5 22.2682 22.8 21.9 22.8ZM14 7.3C16.9 7.3 17.8 8.1 17.8 11.1V21.3H20.3V8.2C20.3 7 20.3 6.6 20.1 6.3C19.9 6 19.5 5.8 18.5 5.3L14.2 3.1C14.0637 3.01563 14.0363 2.9961 13.9 2.9C13.9 2.9 13.9 3.1 13.9 3.3V7.3H14ZM6.30003 21.2V12.7H4.10003C4.00003 12.7 3.90003 12.7 3.90003 12.7C3.90003 12.7 3.90003 12.8 3.90003 12.9V21.2H6.30003ZM16.2 21.2V11C16.2 8.9 16 8.8 14 8.8H10C7.90003 8.8 7.80003 9 7.80003 11V21.2H16.2Z"
				fill="currentColor"
			/>
			<path
				d="M3.27582 1.68974C3.47507 0.949732 4.52499 0.949733 4.72424 1.68974L4.94843 2.52239C5.01792 2.7805 5.21954 2.98211 5.47765 3.0516L6.31029 3.27579C7.0503 3.47504 7.0503 4.52496 6.31029 4.72421L5.47764 4.9484C5.21954 5.01789 5.01792 5.21951 4.94843 5.47761L4.72424 6.31026C4.52499 7.05027 3.47507 7.05027 3.27582 6.31026L3.05164 5.47761C2.98214 5.21951 2.78053 5.01789 2.52242 4.9484L1.68977 4.72421C0.949762 4.52496 0.949764 3.47504 1.68977 3.27579L2.52242 3.0516C2.78053 2.98211 2.98214 2.7805 3.05164 2.52239L3.27582 1.68974Z"
				fill="currentColor"
			/>
		</svg>
	);
}

Hotel2Icon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Hotel2Icon;
